module.exports = __webpack_public_path__ + "static/media/icon_instrument_harmonica.247d3943.svg";